import { t } from '../../../i18n';

export const ExpirationItems = [
  ...[0, 5, 10, 15, 20, 25, 30, 45, 60].map((minutes) => ({
    label: `${minutes} ${t("general.minutes")}`,
    value: `${minutes}`,
  })),
];
